import React, { type PropsWithChildren } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Modal } from '@garnish/overlays';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderIntroModal = (props: GroupOrderIntroModalProps) => {
  const { visible, children } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      size="medium"
      fitHeight
      visible={visible}
      withSafeAreaView={false}
      maxWidth={480}
      accessibilityLabel={formatMessage(messages.modalA11yLabel)}
      contentContainerStyle={styles.modalContainer}
      backdropOpacity={0.8}
    >
      <View style={styles.container}>
        <ScrollView
          contentContainerStyle={styles.innerContainer}
          showsVerticalScrollIndicator={false}
          bounces={false}
        >
          {children}
        </ScrollView>
      </View>
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  modalA11yLabel: {
    defaultMessage: 'Group order introduction',
    description: 'Group Order Intro | Modal | a11y label',
  },
  closeBtnA11yLabel: {
    defaultMessage: 'Close',
    description: 'Group Order Intro | Modal | Close button a11y label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  // NOTE: Reset original styles
  modalContainer: {
    backgroundColor: theme.colors.OPACITY.TRANSPARENT,
    boxShadow: 'none',
    elevation: 0,
  },
  container: {
    overflow: 'hidden',
    flexGrow: 1,
    flexShrink: 1,
    borderRadius: theme.radius.xlarge,
    marginTop: theme.spacing['6'],
    marginBottom: Platform.select({ web: theme.spacing['6'], default: 0 }),
    marginHorizontal: theme.spacing['4'],
    ...theme.elevations['2'],
  },
  innerContainer: {
    backgroundColor: theme.colors.KALE,
    borderRadius: theme.radius.xlarge,
    overflow: 'hidden',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderIntroModalProps = PropsWithChildren<{
  visible: boolean;
  onRequestClose?: () => void;
}>;
